import React, { useMemo } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const options = [
  { label: 'Custom TCP Rule', value: 'customTcp' },
  { label: 'Custom UDP Rule', value: 'customUdp' },
  { label: 'Custom ICMP Rule', value: 'customIcmp' },
  { label: 'Custom IGMP Rule', value: 'customIgmp' },
  { label: 'All TCP', value: 'allTcp' },
  { label: 'All UDP', value: 'allUdp' },
  { label: 'All ICMP', value: 'allIcmp' },
  { label: 'All IGMP', value: 'allIgmp' },
  { label: 'All Traffic', value: 'allTraffic' },
]

// Define rule-based exclusions per direction
const excludedByDirection: Record<'inbound' | 'outbound', string[]> = {
  inbound: ['customIgmp', 'allIgmp'],
  outbound: ['customIgmp'],
}

interface Props {
  direction?: 'inbound' | 'outbound'
}

export default function RuleTypePicklist({
  name = 'type',
  label = 'Type',
  compact = false,
  direction,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const filteredOptions = useMemo(() => {
    if (!direction) return options
    const excludedValues = excludedByDirection[direction] || []
    return options.filter((opt) => !excludedValues.includes(opt.value))
  }, [direction])

  return (
    <AsyncDropdown compact={compact} name={name} label={label} items={filteredOptions} {...rest} />
  )
}
